import type { IconName } from "../../atoms/icons/icon-registry";
import type { ToastOptions, ToastVariant } from "./types";

function variantIconColorClass(variant: ToastVariant): string {
  switch (variant) {
    case "neutral":
      return "text-luce-neutral-foreground-intermediate";
    case "info":
      return "text-luce-system-info-default";
    case "success":
      return "text-luce-system-success-default";
    case "error":
      return "text-luce-system-danger-default";
    case "warning":
      return "text-luce-system-warning-default";
  }
}

// Figma draws all five filled (Toast Alert `1196:23260`), so the weight is always `fill`
export function getLeadingIconSpec(
  variant: ToastVariant,
  customIcon?: IconName,
): { name: IconName; className: string } {
  const className = variantIconColorClass(variant);
  if (customIcon) return { name: customIcon, className };
  switch (variant) {
    case "neutral":
      return { name: "WarningCircle", className };
    case "info":
      return { name: "Info", className };
    case "success":
      return { name: "CheckCircle", className };
    case "error":
      return { name: "WarningCircle", className };
    case "warning":
      return { name: "WarningCircle", className };
  }
}

export function generateToastId(): string {
  const g = globalThis as { crypto?: { randomUUID?: () => string } };
  if (g.crypto?.randomUUID) {
    return g.crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export function normalizeToastInput(input: string | ToastOptions): ToastOptions {
  if (typeof input === "string") {
    return { headline: input, variant: "neutral" };
  }
  return input;
}
